import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { CacheService, IRegionBO} from '@mapfre-tech/amap3';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class RegionService {
  constructor(private http: HttpClient, private cacheService: CacheService) { }

  className = 'RegionService';

  getAllRegions(cache = true, cacheKey = "allRegions"): Observable<IRegionBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IRegionBO[]>;
    } else {
      const observable = this.http.get<IRegionBO[]>(environment.base_URL + "/regions").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newRegion(region: IRegionBO): Observable<IRegionBO> {
    return this.http.post<IRegionBO>(environment.base_URL + "/regions", region).pipe(tap(() => this.deleteCache()))
  }

  updateRegion(region: IRegionBO, id: number): Observable<IRegionBO> {
    return this.http.put<IRegionBO>(environment.base_URL + `/regions/${id}`, region).pipe(tap(() => this.deleteCache()))
  }

  deleteCache() {
    this.cacheService.deleteCache('allRegions');
  }
}
